import {hasWindow} from '@services/http.service';
import {KNOW_MORE_MESSAGE_URL, MESSAGE_URL} from '@services/urls/message';
import * as CsrHttpService from "@http/csr-http.service";
import * as SsrHttpService from "@http/ssr-http.service";

export const sendMessage = (data) => {
    if (hasWindow()) {
        return CsrHttpService.postWithOutAuth(MESSAGE_URL(), data);
    }
    return SsrHttpService.postWithOutAuth(MESSAGE_URL(), data);
};

export const sendKnowMoreMessage = (data, ctx = null) => {
    if (hasWindow()) {
        return CsrHttpService.postWithAuth(KNOW_MORE_MESSAGE_URL(), data);
    }
    return SsrHttpService.postWithAuth(KNOW_MORE_MESSAGE_URL(), data, ctx);
};
